var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$scopedSlots.default || Object.entries(_vm.$attrs).length)?_c('div',{staticClass:"c-long-read-target"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }